import { Route, Routes } from 'react-router-dom';
import IndexPage from '@/pages/Index';
import NotFound from '@/pages/NotFound';

export default function AppRouter() {
	return (
		<Routes>
			<Route path="/" element={<IndexPage />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}
